import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment } from '@angular/router';
import { APP_MODE, AppMode, resolveAppMode } from '@nimbus-portal/features/app-mode/app-mode';

// APP_MODE is fixed on page load, so entering the wallboard from a user-mode page needs a full load.
// It matches before the lazy module loads, so the user-mode session never imports the wallboard module.
@Injectable({ providedIn: 'root' })
export class WallboardGuard implements CanMatch {
  public constructor(
    @Inject(APP_MODE) private readonly appMode: AppMode,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly router: Router,
  ) {}

  public canMatch(_route: Route, _segments: UrlSegment[]): boolean {
    if (this.appMode === AppMode.Wallboard) {
      return true;
    }

    const url = this.getNavigationUrl();
    const pathname = url.split(/[?#]/)[0];
    if (resolveAppMode(pathname) === AppMode.Wallboard) {
      this.document.location.assign(url);
    }
    return false;
  }

  // The segments carry no query or fragment, and the wallboard link keeps its token in the fragment.
  private getNavigationUrl(): string {
    const urlTree = this.router.currentNavigation()?.extractedUrl;
    return urlTree ? this.router.serializeUrl(urlTree) : '';
  }
}
